
export type TResolveLocationFilters = (newFilters: any) => Promise<any>

export const useDefaultResolveLocationFilters = (): TResolveLocationFilters => {
    const resolveLocationFilters = async (newFilters: any) => newFilters;
    return resolveLocationFilters
}; 